import * as React from "react";
import { useTl, useApiService } from "../../../../hooks";
import { IDataTableColumn, ButtonContainer } from "nsitools-react";
import { ETLCodes } from "../../../../locales";
import { useHistory } from "react-router";
import { ActivityGridDto, ActivitySearch, ActivityApi } from "../../../../api";
import { ERoutes } from "../../../../ERoutes";
import { ViewButton, EditButton, SearchTablePage } from "../../../../components";
import { useGlobalData } from "../../../../contexts";
import { Link } from "react-router-dom";

export interface IActivityListPageProps {}

export const ActivityListPage: React.FunctionComponent<IActivityListPageProps> = (props) => {
  const { currentLanguage } = useGlobalData();
  const { t } = useTl();
  const api = useApiService(ActivityApi);
  const history = useHistory();
  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        computed: true,
        disableSorting: true,
        fieldName: "actions",
        autoFitContent: true,
        render: (row: ActivityGridDto) => (
          <ButtonContainer>
            <ViewButton
              minimal={true}
              onClick={() => history.push(`${ERoutes.activity}/${row.activityId}/detail/view`)}
            />
            <EditButton
              minimal={true}
              onClick={() => history.push(`${ERoutes.activity}/${row.activityId}/detail/edit`)}
            />
          </ButtonContainer>
        ),
      },
      {
        header: () => t(ETLCodes.Name),
        fieldName: "name",
      },
      {
        header: () => t(ETLCodes.Section),
        fieldName: "section",
        render: (row: ActivityGridDto) => (
          <Link target="_blank" to={`${ERoutes.section}/${row.sectionId}/detail/view`}>
            {t(ETLCodes.Section)} {row.section}
          </Link>
        ),
      },
    ],
    [history, t]
  );

  const addItemFunction = React.useCallback(() => {
    history.push(`${ERoutes.activity}/0/detail/edit`);
  }, [history]);

  const searchCriteriasFunction = React.useCallback(() => api.getSearchCriterias(true), [api]);
  const searchFunction = React.useCallback(
    (sObj) => api.baseSearch(ActivitySearch.fromJS({ ...sObj, languageId: currentLanguage.languageId })),
    [api, currentLanguage.languageId]
  );
  const exportFunction = React.useCallback(
    (sObj) => api.exportXlsFile(ActivitySearch.fromJS({ ...sObj, languageId: currentLanguage.languageId })),
    [api, currentLanguage.languageId]
  );

  return (
    <SearchTablePage
      columns={columns}
      getCriteriasFunction={searchCriteriasFunction}
      searchFunction={searchFunction}
      exportFunction={exportFunction}
      addFunc={addItemFunction}
      sortKeys={{ name: "ASC" }}
      breadCrumbs={[{ text: t(ETLCodes.Activities) }]}
    />
  );
};
